import Vue from 'vue';
import _ from 'lodash';

export default new class ConfigService extends Vue {
  /**
   * URLから現在の環境を返却します
   * @returns 
   */
  getCurrentEnv() {
    const host = location.host;
    let env;
    if (_.includes(host, 'www2.ncbank.co.jp')) {
      env = 'PRODUCTION';
    } else if (_.includes(host, 'stg.ncbank.gjd.jp')) {
      env = 'STAGING';
    } else if (_.includes(host, 'atm.ncb.gjd.jp')) {
      env = 'DEVELOPMENT';
    } else if (_.includes(host, 'atm.ncb.gjd.test')) {
      env = 'LOCAL';
    } else {
      // env = 'DEVELOPMENT';
      env = 'LOCALHOST';
    }

    return env;
  }

  /**
   * 環境別GoogleMap APIキーを返却します
   * @returns 
   */
  getMapApiKey() {
    const current = this.getCurrentEnv();
    
    let key;
    switch (current) {
      case 'PRODUCTION':
        key = 'AIzaSyDpZ9-0cpXlNAqbqhEyWPKoEJr7-KnzdTo';
        break;

      case 'STAGING':
        key = 'AIzaSyDpZ9-0cpXlNAqbqhEyWPKoEJr7-KnzdTo';
        break;

      case 'DEVELOPMENT':
        key = 'AIzaSyDSf5BfME9uXb4dCj520MossolFAHPlX9o';
        break;

      case 'LOCAL':
        key = 'AIzaSyDSf5BfME9uXb4dCj520MossolFAHPlX9o';
        break;

      case 'LOCALHOST':
        key = 'AIzaSyDSf5BfME9uXb4dCj520MossolFAHPlX9o';
        break;
    }

    return key;
  }

  getGTMId() {
    const current = this.getCurrentEnv();
    
    let id;
    switch (current) {
      case 'PRODUCTION':
        id = 'GTM-W73LVRV';
        break;

      case 'STAGING':
        id = 'GTM-PLTXTGQ';
        break;

      case 'DEVELOPMENT':
        id = 'GTM-KD3PWVV';
        break;

      case 'LOCAL':
        id = 'GTM-KD3PWVV';
        break;

      case 'LOCALHOST':
        id = 'GTM-KD3PWVV';
        break;
    }

    return id;   
  }
}